import { ClickAwayListener, Tooltip } from "@material-ui/core"
import { Ban } from "lucide-react"
import React, { useCallback, useState } from "react"
import { format, parseISO } from "date-fns"
import MarkdownWrapper from "../../../MarkdownWrapper"
import DailyTimestamp from "../utils/DailyTimestamp"
import MessageDivider from "../utils/MessageDivider"

/**
 * @typedef {Object} Contact
 * @property {string} name
 */

/**
 * @typedef {Object} RestrictedMessageProps
 * @property {import("../MessageItem").Message} message
 * @property {import("@material-ui/styles").ClassNameMap} classes
 * @property {import("../MessageItem").Message} previousMessage
 * @property {string} messageClass
 * @property {boolean} [isGroup]
 * @property {boolean} [isSameDay]
 * @property {boolean} [dataDescricao]
 * @property {boolean} [lEhConversaInterna]
 * @property {boolean} [lUsuarioLogadoEhParticipante]
 */

const RestrictedMessage = React.memo(
  /**
   * @param {RestrictedMessageProps} props
   */
  ({
    classes,
    message,
    previousMessage,
    messageClass,
    isGroup,
    isSameDay,
    dataDescricao,
    lEhConversaInterna,
    lUsuarioLogadoEhParticipante,
  }) => {
    const [tooltipOpen, setTooltipOpen] = useState(false)

    const handleClick = useCallback((e) => {
      e.stopPropagation()
      setTooltipOpen((prev) => !prev)
    }, [])

    const handleClickAway = useCallback(() => {
      setTooltipOpen(false)
    }, [])

    return (
      <React.Fragment key={message.id}>
        <DailyTimestamp
          message={message}
          previousMessage={previousMessage}
          isSameDay={isSameDay}
          parseISO={parseISO}
          dataDescricao={dataDescricao}
          classes={classes}
        />

        <MessageDivider
          message={message}
          previousMessage={previousMessage}
          classes={classes}
          lEhConversaInterna={lEhConversaInterna}
          lUsuarioLogadoEhParticipante={lUsuarioLogadoEhParticipante}
        />

        <div id={message.id} className={messageClass}>
          {isGroup && <span className={classes.messageContactName}>{message.contact?.name}</span>}

          <div className={classes.textContentItem} style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <ClickAwayListener onClickAway={handleClickAway}>
              <Tooltip
                title="Mensagem enviada por um usuário com nível de acesso superior ou de outro setor."
                placement="top"
                arrow
                open={tooltipOpen}
                onClose={handleClickAway}
              >
                <Ban className={classes.tooltip} onClick={handleClick} style={{ cursor: "pointer" }} />
              </Tooltip>
            </ClickAwayListener>

            <MarkdownWrapper>Você não tem permissão para ver esta mensagem.</MarkdownWrapper>
          </div>

          <span className={classes.timestamp}>
            {message.isEdited && !message.isDeleted && <span>Editada </span>}
            {format(parseISO(message.createdAt), "HH:mm")}
          </span>
        </div>
      </React.Fragment>
    )
  },
)

RestrictedMessage.displayName = "RestrictedMessage"
export default RestrictedMessage
